export type ContractPricingType = "fixed" | "unit_quantity";

export const calculateContractMonthlyAmount = (
  unitPrice?: number | null,
  quantity?: number | null,
): number | undefined => {
  if (
    typeof unitPrice !== "number" ||
    !Number.isFinite(unitPrice) ||
    typeof quantity !== "number" ||
    !Number.isFinite(quantity)
  ) {
    return undefined;
  }
  return Math.round(unitPrice * quantity);
};

export const resolveContractPricingType = (
  pricingType?: string | null,
): ContractPricingType =>
  pricingType === "unit_quantity" ? "unit_quantity" : "fixed";
